// Add wildlife photos here. Place image files in public/assets/wildlife_photos/
// and reference them below with a short italicized description.
const wildlifeData = [
    {
        image: 'assets/wildlife_photos/AsianCommonToad.jpg',
        caption: 'Asian Common Toad'
    },
    {
        image: 'assets/wildlife_photos/BarkScorpion.jpg',
        caption: 'Bark Scorpion'
    },
    {
        image: 'assets/wildlife_photos/BlackjawHuntsman.jpg',
        caption: 'Blackjaw Huntsman'
    },
    {
        image: 'assets/wildlife_photos/ChalkyPercher.jpg',
        caption: 'Chalky Percher'
    },
    {
        image: 'assets/wildlife_photos/DavidBowieHuntsman.jpg',
        caption: 'David Bowie Huntsman'
    },
    {
        image: 'assets/wildlife_photos/DragonheadedCaterpillar.jpg',
        caption: 'Dragon-headed Caterpillar'
    },
    {
        image: 'assets/wildlife_photos/FourLinedTreeFrog.jpg',
        caption: 'Four-lined Tree Frog'
    },
    {
        image: 'assets/wildlife_photos/HouseCentipede.jpg',
        caption: 'House Centipede'
    },
    {
        image: 'assets/wildlife_photos/Katydid.jpg',
        caption: 'Katydid'
    },
    {
        image: 'assets/wildlife_photos/KendallsRockGecko.jpg',
        caption: "Kendall's Rock Gecko"
    },
    {
        image: 'assets/wildlife_photos/LesserMouseDeer.jpg',
        caption: 'Lesser Mouse-deer'
    },
    {
        image: 'assets/wildlife_photos/LichenHuntsman.jpg',
        caption: 'Lichen Huntsman'
    },
    {
        image: 'assets/wildlife_photos/OrientalWhipSnake.jpg',
        caption: 'Oriental Whip Snake'
    },
    {
        image: 'assets/wildlife_photos/PaintedBronzeBack.jpg',
        caption: 'Painted Bronzeback'
    },
    {
        image: 'assets/wildlife_photos/SundaFlyingLemur.jpg',
        caption: 'Sunda Flying Lemur'
    },
    {
        image: 'assets/wildlife_photos/SundaScopsOwl.jpg',
        caption: 'Sunda Scops Owl'
    },
    {
        image: 'assets/wildlife_photos/WaglersPitViper.jpg',
        caption: "Wagler's Pit Viper"
    },
    {
        image: 'assets/wildlife_photos/WhipScorpion.jpg',
        caption: 'Whip Scorpion'
    },
    {
        image: 'assets/wildlife_photos/TrilobiteBeetleLarva.jpg',
        caption: 'Trilobite Beetle Larva'
    }
];

export default wildlifeData;
